import { useCallback } from 'react';
export var useCallLoadMore = function useCallLoadMore(loadMore, limit) {
  return useCallback(function () {
    if (loadMore) {
      loadMore(limit);
    }
  }, [limit, loadMore]);
};